<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :linkConfigurazioni="linkConfigurazioni" :btnRefreshVisible="true"
        :showModalLoading="showModalLoading" :pathResource="pathResource" titoloVisible @refresh="onRefresh">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm"
                @click="onClickNuovoTipoSoggetto">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Struttura</label>
                        <b-form-select v-model="filtroConfigurazioneContabilitaTipiSoggetti.codiceStruttura"
                            :value="null" @input="onChangeStruttura()">
                            <template #first>
                                <b-form-select-option :value="null"> - Tutte - </b-form-select-option>
                            </template>
                            <b-form-select-option v-for="tipoDoc in strutturaOptions" :key="tipoDoc.id"
                                :value="tipoDoc.codiceStruttura"> {{
                                    tipoDoc.denominazione }} ({{ tipoDoc.codiceStruttura }}) </b-form-select-option>
                        </b-form-select>
                    </b-col>
                    <!-- <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Ragione Sociale</label>
                        <b-form-input v-model="filtroConfigurazioneContabilitaTipiSoggetti.ragioneSociale" type="search"
                            id="codice"></b-form-input>
                    </b-col> -->
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"
                        class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{
                            this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <configurazione-contabilita-tipi-soggetti-list-component ref="cmpConfigurazioneContabilitaSoggettiList"
                @afterLoadData="onAfterLoadData"></configurazione-contabilita-tipi-soggetti-list-component>
            <configurazione-contabilita-tipi-soggetti-edit-modal ref="mdlConfigurazioneContabilitaTipiSoggettiEditModal"
                @afterSave="onAfterSavemdlConfigurazioneContabilitaTipiSoggettiEditModal"
                @beforeSave="onBeforeSavemdlConfigurazioneContabilitaTipiSoggettiEditModal" />



        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioneContabilitaTipiSoggettiListComponent from "../components/ConfigurazioneContabilitaTipiSoggettiListComponent.vue";
import ConfigurazioneContabilitaTipiSoggettiEditModal from "../components/ConfigurazioneContabilitaTipiSoggettiEditModal.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
export default {
    mixins: [UtilityMixin, StruttureMixin],
    components: { SaPageLayout, ConfigurazioneContabilitaTipiSoggettiListComponent, ConfigurazioneContabilitaTipiSoggettiEditModal },
    // 
    data() {
        return {
            showModalLoading: false,
            tipologiaOptions: [],
            linkConfigurazioni: "/configurazionecontabilita",
            filtroConfigurazioneContabilitaTipiSoggetti: { codiceStruttura: null, ragioneSociale: null },
            pathResource: "/contabilitasoggettotipi",
            //   filtro: { codiceStruttura: null, idTipoDocumento: null },
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        this.struttureLoadData();
        if (sessionStorage["filtroConfigurazioneContabilitaTipiSoggetti"]) {
            me.filtroConfigurazioneContabilitaTipiSoggetti = JSON.parse(sessionStorage["filtroConfigurazioneContabilitaTipiSoggetti"]);
        }
        me.loadData();

    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpConfigurazioneContabilitaSoggettiList.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneContabilitaTipiSoggetti"] = JSON.stringify(me.filtroConfigurazioneContabilitaTipiSoggetti);
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroConfigurazioneContabilitaTipiSoggetti = { codiceStruttura: null, tipologia: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneContabilitaTipiSoggetti"] = JSON.stringify(me.filtroConfigurazioneContabilitaTipiSoggetti);
            me.loadData();
        },
        onClickNuovoTipoSoggetto() {
            this.$refs.mdlConfigurazioneContabilitaTipiSoggettiEditModal.show(null);
        },
        onChangeStruttura() {
            this.onSubmit();
        },
        onAfterLoadData() {
            this.closeShowModalLoading();
        },
        onAfterSavemdlConfigurazioneContabilitaTipiSoggettiEditModal() {
            this.onSubmit();
        },
        onBeforeSavemdlConfigurazioneContabilitaTipiSoggettiEditModal() { }
    },
};
</script>

<style></style>
